export default __webpack_public_path__ + "static/media/bubble-2.22c35ca9.png";